{
  "helpMessage": "<p>If you’re having trouble, please call us on <a><strong>{{phone}}</strong></a> (then press <strong>Option 2</strong>).</p>",
  "noCode": "Didn’t get the code?",
  "remainingTime": "{{time}} remaining",
  "sendCode": "Send a new code",
  "text": "<p>We’ve sent a 4-digit code to your mobile number: <strong><PhonePlaceholder /></strong></p><p>The code is valid for {{validityMinutes}} minutes.</p><p>Please enter code below to continue.</p>",
  "textExpired": "Please request a new code to continue.",
  "title": "Enter your code",
  "titleExpired": "Your code has expired"
}
